import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { List } from 'palette/List';
import { FiltersTypesItem } from '../components/FiltersTypesItem';

import './FiltersTypes.scss';

export function FiltersTypes({
    setCurrentFilterType,
    isInline,
    id
}) {
    const { dropdownFilters, activeFilters, availableFilters } = useSelector(state => state.filters);

    const filterTypes = useMemo(() => Object.keys(dropdownFilters)
        .filter(type => typeof availableFilters[type] !== 'undefined')
        .map((type) => {
            const count = activeFilters.filter(activeFilter => activeFilter.filterType === type).length;

            return {
                type,
                count
            };
        }), [activeFilters, availableFilters, dropdownFilters]);

    return (
        <div
            className="filters-types"
            id={id}
        >
            <List>
                {filterTypes.map(filterType => (
                    <FiltersTypesItem
                        key={filterType.type}
                        count={filterType.count}
                        isInline={isInline}
                        setCurrentFilterType={setCurrentFilterType}
                        type={filterType.type}
                    />
                ))}
            </List>
        </div>
    );
}
